export class WalletStatementResponse {
  balance: number;
  totalPages: number;
  totalRecords: number;
  statements: WalletStatement[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.statements && this.statements.length > 0) {
      this.statements.forEach((s) => {
        if (s.category) {
          switch (s.category) {
            case 'SMS':
              s.description = 'Envio de SMS';
              break;
            case 'WHATSAPP':
              s.description = 'Envio de WhatsApp';
              break;

            case 'PIX':
            case 'BANK_SLIP':
            case 'CREDIT_CARD':
              if (s.value > 0) {
                s.description = 'WALLET.CREDIT_ADDED_BY_' + s.category;
              } else {
                s.description = 'WALLET.' + s.category;
              }
              break;

            case 'VOUCHER_FASTGET':
              s.description = 'Crédito disponibilizado pela FastGet';
              break;

            default:
              s.description = s.category;
              break;
          }
        }
      });
    } else {
      this.statements = [];
    }
  }
}

export class WalletStatement {
  date: string;
  category: string;
  transactions: number;
  value: number;

  // aux tela
  description: string;
}

export class WalletStatementFilter {
  startDate: string;
  endDate: string;
  page: number;
  size: number;
  orderBy: 'date' | 'value' | 'transactions';
  sort: 'asc' | 'desc';

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    this.orderBy = 'date';
    this.sort = 'desc';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/wallet/models/wallet-statement.model.ts